import { connect } from 'react-redux'

import SchemaManager from '@components/hubspot/SchemaManager'

import services from '@services'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService } = services
  const { CheckSchemaDrift } = coordinators

  const checkSchemaDrift = CheckSchemaDrift({ RestService, HandleError })

  return {
    checkSchemaDrift,
  }
}

export default connect(undefined, mapDispatchToProps)(SchemaManager)
